<template>
	<div class="signup container">
		<div class="card darken-3 center-align">
			<div class="row">
				<h3 class="card-content teal-text">Sign up</h3>
			</div>
			<div class="card-content">
				<form class="col s12">
					<div class="row">
						<div class="input-field col s12">
							<i class="material-icons prefix">email</i>
							<input type="email" id="email" class="validate" v-model="email" />
							<label for="email">E-mail</label>
							<span class="helper-text left" data-error="Wrong format"></span>
						</div>
					</div>
					<div class="row">
						<div class="input-field col s6">
							<i class="material-icons prefix">account_circle</i>
							<input id="username" type="text" class="validate" v-model="username" />
							<label for="username">Username</label>
						</div>
						<div class="input-field col s6">
							<i class="material-icons prefix">vpn_key</i>
							<input id="last_name" type="password" class="validate" v-model="password" />
							<label for="password">Password</label>
						</div>
					</div>
					<div v-if="feedback" class="row">
						<span class="red-text">{{ feedback }}</span>
					</div>
					<div class="row">
						<div class="btn waves-effect waves-light" @click="signup">
							Submit
							<i class="material-icons right">send</i>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import firebase from 'firebase'
import db from '@/firebase/init'
import slugify from 'slugify'

export default {
	name: "Signup",
	data() {
		return {
			email: null,
			username: null,
			password: null,
			slug: null,
			feedback: null
		}
	},
	methods: {
		signup() {
			if (!this.email || !this.password) {
				this.feedback = "You must fill in all fields!"
				return
			}

			firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
				.then(cred => {
					this.feedback = null

					const user = cred.user

					this.slug = slugify(this.username, {
						replacement: '-',
						remove: /[$*_+~.()'"!\-:&@]/g,
						lower: true
					})

					db.collection("users").doc(this.slug).set({
						username: this.username,
						user_uid: user.uid,
						todos: []
					})

					this.$router.push({ name: "Index" })
				})
				.catch(err => this.feedback = err)
		}
	}
}
</script>

<style>
.signup {
	max-width: 600px;
}
</style>


// WEBPACK FOOTER //
// src/components/auth/Signup.vue